import _classCallCheck from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/john_richardson/mapping-impactful-media/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QualifierValue } from "../../internal/qualifier/QualifierValue";
import { Action } from "../../internal/Action";
import { Qualifier } from "../../internal/qualifier/Qualifier";
/**
 * @description - This Action, while belonging to Effect, acts as a modified overlay.
 *                The class implements the Builder pattern, where strength() and preserveColor()
 *                are applied to the instance, and toString() is responsible to combining them into the right result.
 * @extends SDK.Action
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var StyleTransfer = /*#__PURE__*/function (_Action) {
  _inherits(StyleTransfer, _Action);

  var _super = _createSuper(StyleTransfer);

  /**
   * The Image Source used to create the style transfer,
   * Use the Image Source builder to quickly create a source:
   * </br>Import: {@link Qualifiers.Source|import Sources from '@cloudinary/base/qualifiers/sources';}
   * </br>Create: `Source.image('dog')`
   * @param {ImageSource} imageSource
   */
  function StyleTransfer(imageSource) {
    var _this;

    _classCallCheck(this, StyleTransfer);

    _this = _super.call(this);
    _this.imageSource = imageSource;
    return _this;
  }
  /**
   * Determines the strength in which the styleTransfer is applied.
   * @param {number} [effectStrength] - The strength level, 1-100, default: 100
   * @return {this}
   */


  _createClass(StyleTransfer, [{
    key: "strength",
    value: function strength() {
      var effectStrength = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.effectStrength = effectStrength;
      return this;
    }
    /**
     * More aggressively preserves the colors of the the target photo,
     * Can be used with `strength()` to enhance this behaviour
     * @param {boolean} bool
     * @return {this}
     */

  }, {
    key: "preserveColor",
    value: function preserveColor() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.preserve = bool;
      return this;
    }
    /**
     * The `build` phase of the Action, used internally to concat all the options received into a single string.
     * The result of this method is the toString() of the imageLayer provided in the constructor.
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      var NAME = 'style_transfer';
      var PRES = this.preserve ? 'preserve_color' : null;
      var STRENGTH = this.effectStrength; // Create the style effect

      var styleEffect = new Qualifier('e', new QualifierValue([NAME, PRES, STRENGTH])); // Handle the source for publicID,

      var sourceOpenString = this.imageSource.getOpenSourceString('l'); // Handle source transformation

      var imgTx = this.imageSource.getTransformation();
      var sourceTransformation = imgTx ? imgTx.toString() : '';
      return [sourceOpenString, sourceTransformation, "".concat(styleEffect, ",fl_layer_apply")].filter(function (a) {
        return a;
      }).join('/');
    }
  }]);

  return StyleTransfer;
}(Action);

export { StyleTransfer };